var _defs, _rect, _rect2, _circle, _text, _text2, _text3, _text4, _rect3, _circle2, _text5, _text6, _rect4, _circle3, _text7, _text8, _rect5, _circle4, _text9, _text0, _text1, _rect6, _circle5, _text10, _text11, _text12, _path, _rect7, _circle6, _text13, _text14, _text15, _path2, _rect8, _circle7, _text16, _text17, _text18, _path3, _rect9, _circle8, _text19, _text20, _text21, _rect0, _text22, _text23, _text24, _rect1, _circle9, _text25, _text26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportRenewalSchedulerTrainingCohortTimelineMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 1420,
    viewBox: "0 0 620 1420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Work Passport intelligent renewal scheduler mobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wp-rs-mobile-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF3FD"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 584,
    height: 1384,
    rx: 36,
    fill: "url(#wp-rs-mobile-bg)",
    stroke: "#29405D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 48,
    width: 528,
    height: 118,
    rx: 22,
    fill: "#07152A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 88,
    r: 9,
    fill: "#30D6A1"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 84,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.3
  }, "RENEWAL INTELLIGENCE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 132,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "First Aid renewal cohort")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 516,
    y: 132,
    textAnchor: "end",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 850
  }, "PROPOSED")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 212,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.3
  }, "FORECASTED NEED")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 238,
    width: 160,
    height: 116,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 264,
    r: 5,
    fill: "#087CFF"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 310,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 880
  }, "14")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 336,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 820,
    letterSpacing: 0.8
  }, "EMPLOYEES")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 238,
    width: 160,
    height: 116,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 264,
    r: 5,
    fill: "#FF2775"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 243,
    y: 310,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 880
  }, "3")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 243,
    y: 336,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 820,
    letterSpacing: 0.8
  }, "ACTIVE SITES")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 238,
    width: 160,
    height: 116,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 423,
    cy: 264,
    r: 5,
    fill: "#30D6A1"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 310,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 34,
    fontWeight: 880
  }, "8h")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 336,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 820,
    letterSpacing: 0.8
  }, "GROUP DOWNTIME")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 406,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.3
  }, "COMPLETION WINDOWS")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 438,
    width: 528,
    height: 132,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 504,
    r: 30,
    fill: "#087CFF",
    fillOpacity: 0.13
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 510,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 880
  }, "MAY")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 144,
    y: 486,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "OPTIONAL WINDOW")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 144,
    y: 521,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 820
  }, "Choose an early session")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310 570v36m-8-9 8 9 8-9",
    fill: "none",
    stroke: "#8BCBFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 606,
    width: 528,
    height: 132,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 672,
    r: 30,
    fill: "#30D6A1",
    fillOpacity: 0.13
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 678,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 880
  }, "JUNE")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 144,
    y: 654,
    fill: "#30D6A1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "RECOMMENDED")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 144,
    y: 689,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 820
  }, "Complete with the cohort")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310 738v36m-8-9 8 9 8-9",
    fill: "none",
    stroke: "#8BCBFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 774,
    width: 528,
    height: 132,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 840,
    r: 30,
    fill: "#F5B642",
    fillOpacity: 0.13
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 846,
    textAnchor: "middle",
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 880
  }, "JULY")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 144,
    y: 822,
    fill: "#F5B642",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "FINAL WINDOW")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 144,
    y: 857,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 820
  }, "Escalation begins")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M310 906v36m-8-9 8 9 8-9",
    fill: "none",
    stroke: "#8BCBFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 942,
    width: 528,
    height: 132,
    rx: 20,
    fill: "#FFFFFF",
    stroke: "#D2E1F2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 1008,
    r: 30,
    fill: "#FF6B67",
    fillOpacity: 0.13
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 1014,
    textAnchor: "middle",
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 880
  }, "AUGUST")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 144,
    y: 990,
    fill: "#FF6B67",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "EXPIRY")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 144,
    y: 1025,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 820
  }, "Deployment at risk")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 1134,
    width: 528,
    height: 210,
    rx: 22,
    fill: "#07152A"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 1178,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.3
  }, "PROPOSED TRAINING GROUP")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 1222,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "14 employees \xB7 3 sites")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 1260,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 680
  }, "One coordinated First Aid session")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 1286,
    width: 258,
    height: 42,
    rx: 13,
    fill: "#E7F8F2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 1307,
    r: 6,
    fill: "#30D6A1"
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 1313,
    fill: "#08755A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Lowest predicted disruption")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 1380,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "Illustrative scheduling recommendation")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportRenewalSchedulerTrainingCohortTimelineMobile);
export default __webpack_public_path__ + "static/media/work-passport-renewal-scheduler-training-cohort-timeline-mobile.b096395a4f306750f47206a2430057c5.svg";
export { ForwardRef as ReactComponent };